import React from 'react';
import styles from "./thankyou.module.scss";
import { WelcomeHeader } from '../welcomeHeader';
import store from '../../store/redux-store/root_store';
import VmCustomerFeedbackForm from '../joinMeetingScreen/customerVideo/vmCustomerFeedbackForm';
type thankProps={
  type:string;
}
export const JoinMeetingThankspage = ({type}:thankProps) => {
  const {cSatOpen}:any=store.getState().meetingReducer;
 
  return (<>
    <WelcomeHeader></WelcomeHeader>
    <div className={styles.thanksSec}>
      {type === "end" ? <div className={styles.thanksPop}>
        <h3>Thanks for contacting us!</h3>
      </div> : <div className={styles.expirePop}><h3>This video call link has expired</h3></div>}
    </div>
    {
      type === "end" && cSatOpen && <VmCustomerFeedbackForm/>
    }
  </>);
};